import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { CONTAINER_DEFINITION_CRUD } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

const initialState: any = {}

const containerDefinitionSlice = createSlice({
  name: 'containerDefinition',
  initialState,
  reducers: {},
})

export default containerDefinitionSlice

export const getContainerDefinitionsListAPICall = createAsyncThunk(
  'containerDefinition/getContainerDefinitionsList',
  async (payload: any) => {
    const requestedData: any = CONTAINER_DEFINITION_CRUD.LISTING(payload)
    const data: any = await mainApiService(requestedData)
    return data
  },
)
